import { ColumnFilterInputType, VmOrderFields } from "@/admin/graphql.gen/graphql.ts";
import { GET_VMS } from "@/admin/vm/VmsTable.tsx";
import { vmStatuses } from "@/modules/compute/statusLabels.tsx";
import { useSuspenseQuery } from "@apollo/client/react";

export function useGetVmItemForAdmin(vmUuid: string, location: string) {
    const q = useSuspenseQuery(GET_VMS, {
        variables: {
            locations: [location],
            filters: [
                { field: VmOrderFields.Uuid, value: vmUuid, type: ColumnFilterInputType.Exact },
                // XXX: This is needed for DELETED, CREATING VMs details view
                // TODO: create proper GraphQL endpoint for this
                {
                    field: VmOrderFields.Status,
                    value: vmStatuses.join(","),
                    type: ColumnFilterInputType.List,
                },
            ],
        },
    });
    return q.data.admin_vm_list?.items?.[0];
}
